import LeftSide from "./settingSidebar";
import { Outlet } from "react-router-dom";
const Settings = () => {
  return (
    <div className="flex h-screen bg-white">
      {/* settings Sidebar */}
      <LeftSide />

      {/* Main Content */}
      <Outlet />
    </div>
  );
};

export default Settings;
